import React from 'react';
import cx from 'classnames';
import styles from './HeadingCard.module.scss';
import HeadingCardProps from './HeadingCard.types';
import Heading from '../Heading';
import LanguageSelect from '../../molecules/LanguageSelect';

const HeadingCard = ({
  children,
  className,
  centerContent,
  dataCy,
  headerText,
  heading = 'h2',
  noPadding,
  languageSelection,
}: HeadingCardProps) => {
  let card = (
    <div
      data-cy={dataCy}
      className={cx(styles.card, className, {
        [styles.center]: centerContent,
        [styles.noPadding]: noPadding,
      })}>
      {languageSelection && (
        <div className={styles.languageContainer}>
          <LanguageSelect />
        </div>
      )}
      {children}
    </div>
  );

  if (headerText) {
    card = (
      <>
        <Heading heading={heading}>{headerText}</Heading>
        {card}
      </>
    );
  }

  return card;
};

export default HeadingCard;
